<div class="layout-sidebar">
    <app-menu [model]="menuItems()" />
</div>
